import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { validarEmail } from "app/logic/cliente";


export type Entity = string;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}


/**
* Modal para envíar correo de factura
*/
export class EnviarCorreoModalEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;


    validarSeleccion = (props: Props) => props.value.length == 0 || !validarEmail(props.value);

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;


        const validar = this.validarSeleccion(this.props);
        return (
            <kea.Modal
                buttons={[<kea.Button children="Envíar" style="primary" onClick={this.onGuardar} disabled={validar} />]}
                onClose={this.onCerrar}
                title="Envíar correo"

            >
                <kea.Text label="Correo destino:" value={value} onChange={this.props.onChange} />
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/correo/enviarcorreo/modal.tsx